import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPlate = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: 2.8,
		y: 2.8,
		width: 12.4,
		height: 12.4,
		rx: 3.2,
		stroke: "currentColor",
		strokeWidth: 1.6
	})
});
export default SvgIconPlate;
